import type { LegitimateAny } from "@kivra/sdk/types/util";
import { useOnMount } from "../useOnMount/useOnMount";

export function useOnUnmount(functionToCallOnMount: () => LegitimateAny): void {
  useOnMount(() => functionToCallOnMount);
}
